import CreditCardDisplay from 'profile/creditCard/CreditCardDisplay';

const DisplayCreditCard = (props) => {
  const { clubMembership, onEdit } = props;
  const handleEdit = (e) => {
    e.preventDefault();
    onEdit();
  };

  if (clubMembership.customerCreditCard) {
    return (
      <>
        <strong>Payment details</strong>
        <br />
        <CreditCardDisplay creditCard={clubMembership.customerCreditCard} />
        <br />
        <a onClick={handleEdit} className="c7-button-alt-small">
          Edit
        </a>
      </>
    );
  }
  return (
    <>
      <strong>Payment details</strong>
      <br />
      <div onClick={handleEdit} className="c7-message--error">
        Error: Missing Credit Card
      </div>
      <br />
      <a onClick={handleEdit} className="c7-button-alt-small">
        Add Credit Card
      </a>
    </>
  );
};

export default DisplayCreditCard;
